
// npm
import React from 'react'
import PropTypes from 'prop-types'

// react
import {Popup} from 'components/layout/popup'
import {CancelButton} from './buttons/cancel'
import {ConfirmButton} from './buttons/confirm'
import {withMessages} from 'components/hocs/messages'

// constants
import {MESSAGE_IDS} from 'constants/message-ids'


const practiceFinishConfirmTitle2 = MESSAGE_IDS.EXAM.FINISH_CONFIRM_PRACTICE_TITLE_2;
const practiceFinishConfirm2 = MESSAGE_IDS.EXAM.FINISH_CONFIRM_PRACTICE_INFO_2;


let PracticeFinishConfirmPopup2 = ({onClose, onConfirm, messages}) =>
{
	const props = {
		title: messages[practiceFinishConfirmTitle2],
		content: {text: messages[practiceFinishConfirm2]},
		buttons: [
			<ConfirmButton onClick={onConfirm}/>,
			<CancelButton onClick={onClose}/>
		],
		onClose
	}

	return <Popup {...props}/>;
}

PracticeFinishConfirmPopup2.propTypes = {
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	messages: PropTypes.shape({
		[practiceFinishConfirmTitle2]: PropTypes.string.isRequired,
		[practiceFinishConfirm2]: PropTypes.string.isRequired
	}).isRequired
}


PracticeFinishConfirmPopup2 = withMessages(PracticeFinishConfirmPopup2);


export {PracticeFinishConfirmPopup2}